import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    // 24 hours in milliseconds
    const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;
    // Check if we have a saved end time
    let endTime = localStorage.getItem('guardiaAtlasTimerEnd');
    if (!endTime) {
      // Set new end time 24h from now
      endTime = (new Date().getTime() + TWENTY_FOUR_HOURS).toString();
      localStorage.setItem('guardiaAtlasTimerEnd', endTime);
    }
    const calculateTimeLeft = () => {
      const difference = parseInt(endTime!) - new Date().getTime();
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor(difference / (1000 * 60 * 60) % 24),
          minutes: Math.floor(difference / 1000 / 60 % 60),
          seconds: Math.floor(difference / 1000 % 60)
        });
      } else {
        // Reset timer if it expired (for demo purposes)
        const newEndTime = (new Date().getTime() + TWENTY_FOUR_HOURS).toString();
        localStorage.setItem('guardiaAtlasTimerEnd', newEndTime);
      }
    };
    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex flex-col items-center justify-center my-6" data-id="element-79">
      <div className="inline-block bg-urgency-red text-white text-xs font-bold px-3 py-1 rounded-full mb-3 uppercase tracking-wider" data-id="element-80">
        Oferta por tiempo limitado
      </div>

      <p className="text-gray-500 text-sm font-medium mb-2" data-id="element-81">Termina en</p>

      <div className="flex gap-2 md:gap-4 mb-6" data-id="element-82">
        <TimeBox value={formatNumber(timeLeft.days)} label="DÍAS" data-id="element-83" />
        <span className="text-2xl font-bold text-gray-400 mt-2" data-id="element-84">:</span>
        <TimeBox value={formatNumber(timeLeft.hours)} label="HORAS" data-id="element-85" />
        <span className="text-2xl font-bold text-gray-400 mt-2" data-id="element-86">:</span>
        <TimeBox value={formatNumber(timeLeft.minutes)} label="MIN" data-id="element-87" />
        <span className="text-2xl font-bold text-gray-400 mt-2" data-id="element-88">:</span>
        <TimeBox value={formatNumber(timeLeft.seconds)} label="SEG" data-id="element-89" />
      </div>

      <div className="w-full max-w-xs" data-id="element-90">
        <div className="flex justify-between text-xs font-bold text-gray-600 mb-1" data-id="element-91">
          <span data-id="element-92">Cupos restantes</span>
          <span className="text-urgency-red" data-id="element-93">68% TOMADOS</span>
        </div>
        <div className="h-2 w-full bg-gray-200 rounded-full overflow-hidden" data-id="element-94">
          <div className="h-full bg-urgency-red w-[68%] rounded-full" data-id="element-95"></div>
        </div>
      </div>

      <p className="text-xs text-gray-500 mt-4 text-center max-w-sm" data-id="element-96">
        Cuando se acaben los cupos el precio sube $10.000 y NO vuelve a bajar.
      </p>
    </div>;
}
function TimeBox({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-97">
      <div className="bg-gray-900 text-white font-heading font-bold text-2xl md:text-3xl w-12 h-12 md:w-16 md:h-16 flex items-center justify-center rounded-lg shadow-inner" data-id="element-98">
        {value}
      </div>
      <span className="text-[10px] md:text-xs text-gray-500 font-bold mt-1" data-id="element-99">
        {label}
      </span>
    </div>;
}